module.exports = __webpack_public_path__ + "static/media/icon_mission_calendar.99ba8bd7.svg";